/**
 * How the front end tells a baseline from a branch (issue #97, phase D).
 *
 * A baseline is a REF STRING, `baseline:<tag>`, that rides wherever a branch name
 * does: `GET /api/projects/current` reports it as `branch` while it is the person's
 * current view, and the same value is what switches to it. Kept in one place so
 * the prefix is spelled once and a screen asks "is this a baseline?" the same way
 * everywhere - the default-branch rule that gates editing is a test on the branch
 * NAME, and a baseline must not slip past it by being an unfamiliar one.
 */

/** What a baseline's ref starts with. */
export const BASELINE_PREFIX = 'baseline:'

/** The ref that switches the person's view to this baseline. */
export function baselineRef(tag: string): string {
  return `${BASELINE_PREFIX}${tag}`
}

/** The tag if `ref` is a baseline's, else null. */
export function baselineTag(ref: string | null | undefined): string | null {
  if (!ref || !ref.startsWith(BASELINE_PREFIX)) return null
  return ref.slice(BASELINE_PREFIX.length) || null
}

/**
 * The tag of the baseline being viewed, or null.
 *
 * Either signal counts: the server's `whoami.baseline` and the current branch
 * ref. They are the same fact read from two places, and a screen that has only
 * one of them loaded must still treat the view as read-only.
 */
export function viewedBaseline(
  principalBaseline: string | null | undefined,
  branch: string | null | undefined,
): string | null {
  return principalBaseline || baselineTag(branch)
}
